module.exports = __webpack_public_path__ + "img/freestyle_box11.ff55ef6b.jpg";